import React from 'react'

const Contact = () => {
    return (
        <div>
            <div className='container'>
                <h1
                    class="max-w-2xl p-10 mx-auto text-center font-manrope font-bold text-4xl text-gray-900 mb-5 md:text-5xl leading-[50px]">
                    Contact Us
                </h1>
                <p class="max-w-4xl p-10 mx-auto text-center text-xl font-normal leading-7 text-gray-500 mb-9">
                    Feel free to fill out the form below to get in touch with us OR email us directly at: info@Sevelian.in (NOTE: Please include your order number in message)
                    <p className='text-base p-5 font-bold text-slate-800'>The fastest way to reach us is through !!</p>
                    <div className='p-5'>
                        WhatsApp number : 7840943711<br /><br />

                        Calling number : 7840943711 (10 am to 6pm)<br />
                        Email - customer@Sevelian.in
                    </div>
                </p>
            </div>
        </div>
    )
}

export default Contact